import { useEffect } from "react";

const sureMessage = "Are you sure you want to leave the page?";

const useBeforeUnload = (showMessage?: boolean) => {
  useEffect(() => {
    if (!showMessage) {
      return;
    }
    window.onbeforeunload = function (e: BeforeUnloadEvent) {
      e = e || window.event;

      // For IE and Firefox prior to version 4
      if (e) {
        e.returnValue = sureMessage;
      }

      // For Safari
      return sureMessage;
    };
    return () => {
      window.onbeforeunload = null;
    };
  });
};

export default useBeforeUnload;
